import { render, staticRenderFns } from "./FundingAssessmentsBase.vue?vue&type=template&id=5819262c&"
import script from "./FundingAssessmentsBase.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports